export default __webpack_public_path__ + "static/media/marketcap.9ea3bf7d.svg";